module.exports = __webpack_public_path__ + "img/file drop.a34c0109.svg";